import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { Router } from '@angular/router';
import { TestSuiteViewModel } from '../viewmodels/test-suite.viewmodel';
import { FuntionalAreaService } from '../services/test-suite.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/toast/toast.service';
import { ScenarioService } from '../../scenario/services/scenario.service';
import { PackagesService } from '../../packages/services/packages.service';
import { ClientService } from '../../client/services/client.service';
import { AuthService } from '../../../auth/login/services/auth.service';

@Component({
  selector: 'app-test-suite',
  imports: [
    InputTextModule, FluidModule, ButtonModule, SelectModule, FormsModule,
    TextareaModule, ToolbarModule, TableModule, InputIconModule, IconFieldModule,
    DialogModule, CommonModule, ToastModule, ConfirmDialogModule, ReactiveFormsModule,
    TooltipModule
  ],
  templateUrl: './test-suite.component.html',
  styleUrl: './test-suite.component.scss',
  providers: [ConfirmationService, ToastService]
})
export class TestSuiteComponent implements OnInit {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private funtionalAreaService = inject(FuntionalAreaService);
  private scenarioService = inject(ScenarioService);
  private packageService = inject(PackagesService);
  private clientService = inject(ClientService);
  private router = inject(Router);
  private authService = inject(AuthService);

  public viewModel!: TestSuiteViewModel;
  @ViewChild('dt') dt!: Table;

  ngOnInit(): void {

    try {
      this.viewModel = new TestSuiteViewModel(this.http, this.toastService, this.confirmationService, this.funtionalAreaService, this.scenarioService, this.router, this.packageService, this.clientService, this.authService);
      this.viewModel.init();

    } catch (error) {
    }
  }
}